// Older save flows stringified `undefined` into text fields (e.g. footerText / description)
// before persisting; on subsequent loads those literal strings come back and would
// round-trip again. Returning '' breaks the loop so the field self-heals on the next save.
export const sanitizeStringField = (value: string | null | undefined): string =>
  !value || value === 'undefined' ? '' : value
